// The collector that runs ON the State's CPL Record Search page, in the person's own signed-in browser.
// It fills in the search (License %, one submission period at a time), waits for the page's own table to fill, and keeps what the table holds.
// Then it offers two buttons: send it to the POS (a new POS tab opens and receives it, using the POS sign-in), or save it as a file.
// It reads what the page already shows. It does not sign in, change or submit anything. The State's page does not let a script send data
// to another website, so the hand-over uses a window the person opens by clicking, and a message between the two windows.

/** Plain JavaScript, kept as a string so it can be a bookmark, or pasted into the browser console. */
export const COLLECTOR_SOURCE = `
(async function () {
  var P = window.__pos;
  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var old = document.getElementById('njpos-cpl-box'); if (old) old.remove();
  var box = document.createElement('div'); box.id = 'njpos-cpl-box';
  box.style.cssText = 'position:fixed;z-index:2147483647;right:16px;bottom:16px;max-width:440px;background:#14301f;color:#fff;font:14px/1.45 Arial,sans-serif;padding:14px 16px;border-radius:10px;box-shadow:0 4px 20px rgba(0,0,0,.35)';
  var msg = document.createElement('div'); var actions = document.createElement('div');
  box.appendChild(msg); box.appendChild(actions); document.body.appendChild(box);
  var say = function (m) { msg.textContent = 'POS price list: ' + m; };
  var button = function (label, fn) { var b = document.createElement('button'); b.textContent = label; b.style.cssText = 'margin:10px 8px 0 0;padding:8px 14px;border:0;border-radius:8px;font-weight:700;cursor:pointer;background:#e1b04a;color:#14301f'; b.onclick = fn; actions.appendChild(b); return b; };
  try {
    var fr = Array.prototype.slice.call(document.querySelectorAll('iframe')).filter(function (f) { try { return f.contentWindow.Ext && f.contentWindow.Ext.getCmp('grid_CPL'); } catch (e) { return false; } })[0];
    if (!fr) { say('Open the "CPL Record Search" page first, then click this again.'); button('Close', function () { box.remove(); }); return; }
    var Ext = fr.contentWindow.Ext;
    var field = function (name) { return Ext.ComponentQuery.query('field[name=' + name + ']')[0]; };
    var lic = field('licensenumber'), per = field('submissionperiod');
    var cplStore = Ext.getCmp('grid_CPL').getStore();
    var ripGrid = Ext.getCmp('grid_RIP'); var ripStore = ripGrid && ripGrid.getStore();
    var now = new Date(), next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    var label = function (d) { return d.toLocaleString('en-US', { month: 'long', year: 'numeric' }); };
    var wanted = (window.__cplMonths && window.__cplMonths.length) ? window.__cplMonths : [label(now), label(next)];
    var CPL = ['submissionperiod','submissiontype','upc','fromdate','todate','brandregistrationnum','producttype','productname','vintage','prooforabv','unittype','unitquantity','unitvolume','ripcode','combocode','closeoutpermitnumber','frontlinecaselistprice','frontlineunitlistprice','bestcaseprice','bestunitprice','splitcaseunitprice','discountqty1','discountamt1','discountqty2','discountamt2','discountqty3','discountamt3'];
    var RIP = ['submissionperiod','submissiontype','ripcode','upc','brandregistrationnum','fromdate','todate','ripdescription','ripunit1','ripqty1','ripamt1','ripunit2','ripqty2','ripamt2'];
    var ymd = function (v) { var d = new Date(v); return isNaN(d) ? v : d.toLocaleDateString('en-CA', { timeZone: 'America/New_York' }); };
    var pick = function (rec, keys) { var o = {}; keys.forEach(function (k) { var v = rec.get(k); o[k] = (k === 'fromdate' || k === 'todate') ? ymd(v) : (v === undefined || v === null ? '' : v); }); return o; };
    var docs = [], notes = [];
    for (var i = 0; i < wanted.length; i++) {
      var m = wanted[i];
      var rec = per.getStore().findRecord('displayvalue', m, 0, false, false, true);
      if (!rec) { notes.push(m + ': not published yet'); continue; }
      say('searching ' + m + '… about half a minute. Keep this tab open.');
      lic.setValue('%'); per.select(rec); per.fireEvent('select', per, rec);
      cplStore.removeAll(); if (ripStore) ripStore.removeAll();
      Ext.getCmp('searchbutton').fireHandler();
      var t0 = Date.now(), last = -1, same = 0;
      while (Date.now() - t0 < 300000) {
        await sleep(1500);
        var n = cplStore.getCount();
        if (!cplStore.isLoading() && n > 0 && n === last) { if (++same >= 3) break; } else same = 0;
        last = n;
        say('loading ' + m + ': ' + n.toLocaleString() + ' rows so far…');
      }
      if (cplStore.getCount() === 0) { notes.push(m + ': nothing found'); continue; }
      var cpl = cplStore.getRange().map(function (r) { return pick(r, CPL); });
      var rip = ripStore ? ripStore.getRange().map(function (r) { return pick(r, RIP); }) : [];
      docs.push({ source: 'abc-cpl-record-search', month: m, collectedAt: new Date().toISOString(), cpl: cpl, rip: rip });
      notes.push(m + ': ' + cpl.length.toLocaleString() + ' prices, ' + rip.length + ' rebates');
    }
    window.__cplDocs = docs; window.__cplNotes = notes;
    actions.textContent = '';
    if (!docs.length) { say(notes.join('  |  ')); button('Close', function () { box.remove(); }); return; }
    say(notes.join('  |  ') + '.  Ready.');
    var saveFile = function () {
      docs.forEach(function (d, k) {
        var a = document.createElement('a'); a.href = URL.createObjectURL(new Blob([JSON.stringify(d)], { type: 'application/json' })); a.download = 'NJ_CPL_' + d.month.replace(/\\s+/g, '_') + '.json';
        document.body.appendChild(a); setTimeout(function () { a.click(); a.remove(); }, k * 800);
      });
      say('saved ' + docs.length + ' file(s). In the POS press Import CPL and choose them.');
    };
    var send = function () {
      var base = String(P.url).replace(/\\/$/, ''); var origin = new URL(base).origin;
      var w = window.open(base + '/cpl-analytics?receive=1', 'njpos_cpl');
      if (!w) { say('Your browser blocked the POS window. Allow pop-ups for this site, then click Send again.'); return; }
      var ready = false;
      var onMsg = function (ev) {
        if (ev.origin !== origin) return;
        var d = ev.data || {};
        if (d.type === 'njpos-cpl-ready' && !ready) {
          ready = true; clearInterval(hello);
          docs.forEach(function (doc) { w.postMessage({ type: 'njpos-cpl-doc', doc: doc }, origin); });
          say('sent to your POS. Watch the POS tab: it loads each month and shows the result.');
        }
        if (d.type === 'njpos-cpl-result') say(d.text || 'done');
      };
      window.addEventListener('message', onMsg);
      var hello = setInterval(function () { try { w.postMessage({ type: 'njpos-cpl-hello' }, origin); } catch (e) {} }, 1500);
      setTimeout(function () { clearInterval(hello); if (!ready) say('The POS did not answer. Sign in there if it asks, then click Send again.'); }, 240000);
      say('opening your POS… sign in there if it asks.');
    };
    if (P && P.url) button('Send to my POS', send);
    button('Save as a file', saveFile);
    button('Close', function () { box.remove(); });
  } catch (e) { say('Something went wrong: ' + (e && e.message ? e.message : e)); button('Close', function () { box.remove(); }); }
})();
`;

const compact = (src: string) => src.replace(/\/\/.*$/gm, '').replace(/\s*\n\s*/g, ' ');

/** The bookmark. With the POS address inside it, it offers to send the price list to the POS; it can always save a file instead. */
export function collectorBookmarklet(pos?: { url: string }): string {
  const head = pos ? `window.__pos=${JSON.stringify(pos)};` : '';
  return `javascript:${encodeURIComponent(head + compact(COLLECTOR_SOURCE))}`;
}

export const COLLECTOR_BOOKMARKLET = collectorBookmarklet();
